import { MouseEventHandler } from 'react'

// import { theme } from '@hhgtech/hhg-components'

// import ChevronRight from 'components/atoms/icons/ChevronRight'

import { StyledSeeMoreWrapper, StyledText } from './index.styled'

export type Props = {
  text: string
  className?: string
  onClick?: MouseEventHandler
}

const SeeMore = ({ text, className = '', ...rest }: Props) => {
  return (
    <StyledSeeMoreWrapper className={className} {...rest}>
      <StyledText>{text}</StyledText>
      {/* <ChevronRight color={theme.colors.primaryBase} size={20} /> */}
    </StyledSeeMoreWrapper>
  )
}

export { SeeMore }
